import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../../api/NestClient';
import { nestBaseQuery } from '../../../utils/nestBaseQuery';
import type {
  CurrentSubscriptionResponse,
  SubscribeWithPromocodeRequest,
  SubscribeWithPromocodeResponse,
  SubscriptionOrdersResponse,
  ValidatePromocodeRequest,
  ValidatePromocodeResponse,
} from '../types/BillingSubscription';

export type {
  CurrentSubscriptionResponse,
  SubscribeWithPromocodeResponse,
  SubscriptionOrdersResponse,
  ValidatePromocodeResponse,
} from '../types/BillingSubscription';

export const billingSubscriptionApi = createApi({
  reducerPath: 'billingSubscriptionApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['CurrentSubscription', 'SubscriptionOrders'],
  endpoints: (builder) => ({
    getSubscriptionOrders: builder.query<SubscriptionOrdersResponse, void>({
      query: () => client.GET('/api/v1/subscription/orders'),
      providesTags: ['SubscriptionOrders'],
    }),
    getCurrentSubscription: builder.query<CurrentSubscriptionResponse, void>({
      query: () => client.GET('/api/v1/subscription/current'),
      providesTags: ['CurrentSubscription'],
    }),
    validatePromocode: builder.mutation<ValidatePromocodeResponse, ValidatePromocodeRequest>({
      query: (body) =>
        client.POST('/api/v1/public/validate-promocode', {
          body,
        }),
    }),
    subscribeWithPromocode: builder.mutation<SubscribeWithPromocodeResponse, SubscribeWithPromocodeRequest>({
      query: (body) =>
        client.POST('/api/v1/subscription/subscribe-with-promocode', {
          body,
        }),
      invalidatesTags: ['CurrentSubscription', 'SubscriptionOrders'],
    }),
  }),
});

export const {
  useGetSubscriptionOrdersQuery,
  useGetCurrentSubscriptionQuery,
  useValidatePromocodeMutation,
  useSubscribeWithPromocodeMutation,
} = billingSubscriptionApi;
